module.exports = __webpack_public_path__ + "static/img/sentinel.51b1eedb.svg";